const menu = {
    Home: '设备管理',
    Buy: '购买云机',
    ValueAddedServices: '增值服务',
    Vas: '增值订单',
    List: '个人中心',
    Order: '订单中心',
}
export default menu;